import React from 'react';

import { Box } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { Switch } from 'react-router-dom';
import { Element } from 'react-scroll';

import {ProtectedRoute} from '../../components/ProtectedRoute';
import { LearnerInfo } from '../../types';
import Manager from './components/Manager';
import User from './components/User';
import useStyles from './styles';

interface AnalyticsPageProps {
  userInfo: LearnerInfo;
  userLoading: boolean;
  width: Breakpoint;
  tenantTitle?: string;
  tenantName?: string | null;
}

const AnalyticsPage: React.FC<AnalyticsPageProps> = ({
  width,
  userInfo,
  userLoading,
  tenantTitle,
  tenantName,
}) => {
  const classes = useStyles();
  const isManager = !!userInfo?.is_manager;
  const isMobile = !isWidthUp('md', width);

  return (
    <Element name="analytic-wrapper">
      <Box className={classes.wrapper}>
        <Switch>
          {isManager && (
            <ProtectedRoute
              path="/analytics/dashboard"
              userInfo={userInfo}
              userLoading={userLoading}
              render={(props) => (
                <Manager
                  isMobile={isMobile}
                  tenantTitle={tenantTitle}
                  userInfo={userInfo}
                  tenantName={tenantName}
                  {...props}
                />
              )}
            />
          )}
          <ProtectedRoute
            userInfo={userInfo}
            userLoading={userLoading}
            path="/analytics"
            withPrevSubscription
            render={(props) => (
              <User
                isMobile={isMobile}
                tenantTitle={tenantTitle}
                userId={userInfo?.id}
                userName={userInfo?.name}
                isManager={isManager}
                tenantName={tenantName}
                hasSubscription={userInfo?.has_subscription}
                {...props}
              />
            )}
          />
        </Switch>
      </Box>
    </Element>
  );
};

export default withWidth()(AnalyticsPage);
